import { useEffect, useMemo, useRef, useState } from "react";
import ResponsiveAppBar from "../../../../layouts/navbar";
import { Footer } from "../../../../layouts/footer";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";
import { getShopListAsync } from "../../../../../app/slices/footerSlice/footerSlice";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { GoogleMapSelector } from "../../../private/profilePage/components/address/GoogleMapSelector";
import { useParams } from "react-router-dom";
import { CircularProgress, useMediaQuery } from "@mui/material";

export const StoreLocations = () => {
  const dispatch = useAppDispatch();
  const [shopData, setShopData] = useState<any[]>([]);
  const [selectedStoreIndex, setSelectedStoreIndex] = useState<number | null>(
    null
  ); // Track selected store index
  const [currentLocation, setCurrentLocation] = useState<
    google.maps.LatLngLiteral | undefined
  >(undefined);
  const { storeId } = useParams();
  const mapRef = useRef<HTMLDivElement | null>(null);
  const isMobileScreen = useMediaQuery("(max-width:560px)");
  // Define map container style
  const containerStyle = {
    width: "100%",
    height: "500px",
    border: "1px solid grey", // Debugging border
  };
  const isLoading = useAppSelector(
    (state) => state.FooterDataState.shopData.loader
  );
useEffect(() => {
  if (!window.google) {
    window.location.reload();
  }
}, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    dispatch(getShopListAsync()).then((response: any) => {
      const data = response?.payload?.data;
      setShopData(data?.shops || []);

      if (data?.shops && data.shops.length > 0) {
        let selectedIndex = 0;
        let lat = 0;
        let lng = 0;

        // Try to find the store by ID from the URL
        if (storeId) {
          const foundIndex = data.shops.findIndex(
            (store: any) => String(store.uuid) === String(storeId)
          );
          if (foundIndex !== -1) {
            selectedIndex = foundIndex;
            lat = Number(data.shops[foundIndex].latitude);
            lng = Number(data.shops[foundIndex].longitude);
          }
        } else {
          lat = Number(data.shops[0].latitude);
          lng = Number(data.shops[0].longitude);
        }

        if (!isNaN(lat) && !isNaN(lng)) {
          setSelectedStoreIndex(selectedIndex);
          setCurrentLocation({ lat, lng });
        }
      }
    });
  }, [dispatch, storeId]);

  // useEffect(() => {
  //   dispatch(getShopListAsync()).then((response: any) => {
  //     const data = response?.payload?.data;
  //     setShopData(data?.shops);

  //     // Ensure we have a valid first store to set as the initial location
  //     if (data?.shops && data.shops.length > 0) {
  //       const firstStore = data.shops[0];
  //       // Check for valid latitude and longitude before setting
  //       const lat = Number(firstStore.latitude);
  //       const lng = Number(firstStore.longitude);
  //       if (!isNaN(lat) && !isNaN(lng)) {
  //         setSelectedStoreIndex(0);
  //         setCurrentLocation({ lat, lng });
  //       }
  //     }
  //   });
  // }, [dispatch]);

  const getGoogleMapsUrl = (store: any) => {
    const lat = Number(store.latitude);
    const lng = Number(store.longitude);
    if (isNaN(lat) || isNaN(lng)) {
      return "https://www.google.com/maps";
    }
    return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
  };

  const getGoogleMapsUrlForLocation = (location: google.maps.LatLngLiteral) => {
    return `https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`;
  };

  const selectedStore =
    selectedStoreIndex !== null ? shopData[selectedStoreIndex] : null;

  const openGoogleMaps = (store: any) => {
    window.open(getGoogleMapsUrl(store), "_blank");
  };

  const handleMapClick = () => {
    if (selectedStore) {
      openGoogleMaps(selectedStore);
    } else if (currentLocation) {
      window.open(getGoogleMapsUrlForLocation(currentLocation), "_blank");
    }
  };

  // Handle store selection and update map center
  const handleStoreClick = (store: any, index: number) => {
    const lat = Number(store.latitude);
    const lng = Number(store.longitude);

    // Check for valid latitude and longitude before setting
    if (!isNaN(lat) && !isNaN(lng)) {
      setSelectedStoreIndex(index);
      setCurrentLocation({ lat, lng });
      if (isMobileScreen) {
        setTimeout(() => {
          mapRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 100);
      }
    }
  };

  // Reorder shops to show selected one first
  const reorderedShops = useMemo(() => {
    if (selectedStoreIndex === null || selectedStoreIndex === undefined) {
      return shopData;
    }
    const selected = shopData[selectedStoreIndex];
    const others = shopData.filter((_, index) => index !== selectedStoreIndex);
    return [selected, ...others];
  }, [shopData, selectedStoreIndex]);

  return (
    <>
      <ResponsiveAppBar />
      <div
        id="wrapper"
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: "400",
        }}
      >
        <h3 className="fs-22 fw-6 text-center mt-5">
          Navya Bakeshop Locations
        </h3>
        <section className="flat-spacing-16 pt-4">
          <div className="container">
            {isLoading ? (
              <div className="row widget-tabs" style={{ minHeight: "50vh" }}>
                <div className="col-xl-4 col-md-5 col-12">
                  <div className="tf-store-list d-flex gap-10 flex-column widget-menu-tab">
                    <CircularProgress
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="row widget-tabs">
                <div className="col-xl-4 col-md-5 col-12">
                  <div
                    className="tf-store-list d-flex gap-10 flex-column widget-menu-tab"
                    style={{ height: "500px", overflowY: "scroll" }}
                  >
                    {reorderedShops.map((store: any, index: number) => {
                      const isSelected = selectedStoreIndex === shopData.indexOf(store);
                      return (
                        <div
                          key={store.uuid}
                          className="tf-store-item item-title default"
                          style={{
                            backgroundColor: isSelected ? "black" : "",
                            color: isSelected ? "white" : "black",
                            cursor: "pointer",
                            padding: "10px",
                            marginBottom: "10px",
                            borderRadius: "5px",
                          }}
                          onClick={() => {
                            const originalIndex = shopData.indexOf(store);
                            handleStoreClick(store, originalIndex);
                          }}
                        >
                          <h6
                            className="tf-store-title"
                            style={{
                              backgroundColor: isSelected ? "black" : "",
                              color: isSelected ? "white" : "black",
                            }}
                          >
                            <div className="icon">
                              <i className="icon-place"></i>
                            </div>
                            {store.unit_name}
                          </h6>
                          <div className="tf-store-info">
                            <span>Address</span>
                            <p>
                              {store.address.street}, {store.address.city},{" "}
                              {store.address.district},{" "}
                              {store.address.state_or_province},{" "}
                              {store.address.pin_code}
                            </p>
                          </div>
                          <div className="tf-store-info">
                            <span>Phone</span>
                            <p>{store.contact_no}</p>
                          </div>
                          <div className="tf-store-info">
                            <span>Email</span>
                            <p>{store.email}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="col-xl-8 col-md-7 col-12">
                  <div>
                    <div className="widget-content-inner p-0" ref={mapRef}>
                      <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={currentLocation}
                        zoom={14}
                        
                        options={{
                          disableDefaultUI: true,
                          zoomControl: true,
                          streetViewControl: true,
                          fullscreenControl: true,
                          mapTypeId: "roadmap",
                        }}
                      >
                        {currentLocation && (
                          <Marker position={currentLocation} onClick={handleMapClick}/>
                        )}
                      </GoogleMap>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};
